import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
// import VIContentPolicy from "modules/Menu/components/policy/ENContentPolicy";
// import KOContentPolicy from "modules/Menu/components/policy/KOContentPolicy";
// import ENContentPolicy from "modules/Menu/components/policy/ENContentPolicy";
import BottomNavigation from "core/layouts/BottomNavigation";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { _t } from "core/language";
import API from "core/networks/API";
import { API_GET_CONTENT_POLICY } from "modules/Auth/api";
import { TypeEnumPolicy } from "core/config/constant";
import { useCallback, useEffect, useState } from "react";
import { useGetLang } from "modules/Auth/hooks";
import { useRecipe } from "modules/Ingredients/hooks/recipe";

const PrivacyPolicy = () => {
  const { resetRecipes } = useRecipe()
  const navigate = useCustomNavigate();
  const { langId } = useGetLang();
  const [contentPolicy, setContentPolicy] = useState("");

  const handleGetContentPolicy = useCallback(async () => {
    const dataRequest = {
      lang_id: langId,
      type: TypeEnumPolicy.PERSONAL_INFORMATION_HANDLING_POLICY,
    };

    try {
      const { data: response } = await API.get(
        `${API_GET_CONTENT_POLICY}`,
        dataRequest
      );
      if (response && response?.code === 200) {
        const content =
          response?.data && response?.data.length > 0
            ? response?.data[0].content
            : "";
        setContentPolicy(content);
      }
    } catch (e: any) {
      console.log(e, "errors");
    }
  }, [langId]);

  useEffect(() => {
    handleGetContentPolicy();
  }, [handleGetContentPolicy]);

  const handleGoBack = () => {
    navigate(-1);
  };

  // const renderContent = () => {
  // 	let appLang = (window as any)._APP_LANG

  // 	switch (appLang) {
  // 		case "en":
  // 			return <ENContentPolicy />
  // 		case "ko":
  // 			return <KOContentPolicy />
  // 		default:
  // 			return <VIContentPolicy />
  // 	}
  // }

  return (
    <AppLayout className={"content-policy-client-page"}>
      <PageHeader
        title={_t("menu.LabelPolicy")}
        showCart={false}
        handleGoBack={() => handleGoBack()}
        className="fixed w-full z-100 bg-white"
      />
      <div className="px-4 pt-[43px]">{/* {renderContent()} */}</div>
      <main className="w-full gap-2.5 content-center items-center px-4 py-8 bg-white ">
        <section className="flex flex-col self-stretch my-auto rounded-lg">
          <h1 className="self-start text-base font-medium tracking-tighter text-neutral-900">
            {_t("menu.AppName")}
          </h1>
          <div className=" px-3.5 py-5 mt-3.5 text-sm tracking-tighter rounded-lg bg-[#F4F4F4] mb-[65px] min-h-[50vh]">
            <div className=" my-auto w-full basis-0 min-w-[240px] ">
              <section className=" mt-5 w-full">
                {/* {renderContent()} */}
                <div dangerouslySetInnerHTML={{ __html: contentPolicy }} />
              </section>
            </div>
          </div>
        </section>
      </main>
      <BottomNavigation activeIndex={5} onNavigateChange={resetRecipes} />
    </AppLayout>
  );
};

export default PrivacyPolicy;
